module.exports = __webpack_public_path__ + "static/salesmate-main-banner-image-0f32ca7d9c1dc9792e24de33e06187a9.png";